import register from '../util/init'
import { dashboard } from './dashboard'
import { toggleSwitchInit } from './qrt_switch'
import { initContainers } from '../util/init'

function onSelectChange (e) {
  const $dashboardEl = document.querySelector('.dashboard')

  let value = e.target.value
  let platform = 'code'
  if (e.target.value.startsWith('service-level')) {
    platform = 'platform'
    value = e.target.value.slice(14).replace(' ', '-')
  } else if (e.target.value.startsWith('kiwisaver')) {
    platform = 'kiwisaver'
    value = e.target.value
  }

  if (window.location.pathname.split('/')[1] === 'advisers') {
    platform = window.location.pathname + '/' + platform
  } 

  window.fetch(platform + '/' + value, {
    credentials: 'include'
  })
    .then(response => {
      if (response.ok) {
        return response.json()
      }
      throw new Error('Network response was not ok.')
    })
    .then(JsonResponse => {
      $dashboardEl.innerHTML = JsonResponse.dashboard_template
      reinitDashboard(value)
      const selectCode = document.querySelector('.overview__user--select-code')
      selectCode.value = e.target.value
    })
}

function reinitDashboard (id) {
  toggleSwitchInit(document.querySelectorAll('.toggle-switch'))
  dashboard(document.querySelectorAll('.dashboard'), id)
  selectCode(document.querySelectorAll('.overview__user--select-code'))

  const dashboardPortfolios = document.querySelectorAll('.portfolio-list.top-five')
  initContainers(dashboardPortfolios)
}

function selectCode (container) {
  const selectCode = document.querySelector('.overview__user--select-code')

  selectCode.addEventListener('change', e => onSelectChange(e))
}

register('.index .overview__user--select-code', selectCode)



// WEBPACK FOOTER //
// ./assets/j/src/dashboard_advisercode.js